import {
  Box,
  Button,
  Divider,
  FormControl,
  HStack,
  Input,
  Pressable,
  SectionList,
  Stack,
  Text,
  useToast,
} from "native-base";
import { useMutation, useQueryClient } from "react-query";
import ApiServices from "../api/api";
import { useEffect, useState } from "react";
import "../i18n/i18n";
import { useTranslation } from "react-i18next";
import { pp, ppw } from "../util/LogUtil";
import Colors from "../const/Colors";
import { View } from "react-native";
import LoadingView from "./element/LoadingView";

var _ = require("lodash");

const Edit = ({ navigation, route }) => {
  pp("Edit()");

  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const id = route?.params?.id;
  const screen_title = route?.params?.screen_title;
  const sectionData = route?.params?.section_data;
  const formDataOld = route?.params?.formDataOld;
  const isEditArg = true;
  const [dataHealth, setDataHealth] = useState([sectionData]);
  const [formData, setFormData] = useState({});
  const mutation = useMutation((data) => ApiServices.update(data));
  const toast = useToast();
  const [uploading, setUploading] = useState(false);
  const [isEdit, setIsEdit] = useState(isEditArg);

  useEffect(() => {
    navigation.setOptions({ title: screen_title });
  }, [navigation, screen_title]);

  const handleClick = async () => {
    setUploading((c) => !c);
    var result = _.omit(formData, ["undefined"]);

    // use new data overwrite old data
    result = _.merge(formDataOld, formData);

    const data = await mutation.mutateAsync<void>({ id, data_healths: result });
    if (data.status == 200) {
      queryClient.invalidateQueries({ queryKey: ["get-all"] });
      toast.show({
        description: t("Updated successful"),
      });
      setUploading((c) => !c);
      navigation.pop();
    }
  };
  const updateValue = (key: any, value: any) => {
    var tmp = dataHealth;
    var arrAppend = [];
    tmp = _.map(tmp, function (item: any) {
      var index = _.findIndex(item.data, { key });
      if (index !== -1) {
        item.data.splice(index, 1, { key, value });
      }
      var list = _.chain(item.data).keyBy("key").mapValues("value").value();
      _.forEach(list, function (value: any, key: any) {
        arrAppend[key] = value;
      });
      return item;
    });
    setDataHealth(tmp);
    setFormData(arrAppend);
  };

  return (
    <Box style={{ flex: 1, backgroundColor: Colors.white }}>
      <LoadingView isOpen={uploading} />
      <Divider />
      <Box style={{ flex: 10 }}>
        <SectionList
          sections={dataHealth}
          keyExtractor={(item: any, index: any) => item + index}
          renderSectionHeader={({ section: { title } }) => (
            <Pressable
              onPress={() => {
                ppw("title", title);
              }}
            >
              <Box
                width="100%"
                bg={Colors.healthCheckSectionHeader}
                paddingX={4}
                paddingY={2}
                borderColor={Colors.healthCheckSectionHeaderBorder}
                borderWidth={1}
              >
                <Text fontSize={16} color={Colors.black}>
                  {t(title)}
                </Text>
              </Box>
            </Pressable>
          )}
          renderItem={({ item }) => (
            <FormControl w="100%">
              <HStack
                borderBottomColor={Colors.healthCheckSectionHeaderBorder}
                borderBottomWidth={1}
                paddingY={2}
                marginX={4}
                // backgroundColor={"red.200"}
              >
                <Stack
                  flex={6}
                  justifyContent={"center"}
                  // backgroundColor={"green.200"}
                >
                  <Text width={"100%"} fontSize={16} color={Colors.black}>
                    {t(item.key)}
                    {/*{item.key}*/}
                  </Text>
                </Stack>
                <View style={{ width: 8 }} />
                <Stack
                  flex={4}
                  // backgroundColor={"red.50"}
                  // backgroundColor={"blue.200"}
                >
                  {isEdit ? (
                    <Input
                      width={"100%"}
                      fontStyle={"bold"}
                      textAlign={"end"}
                      variant={isEdit ? "underlined" : "unstyled"}
                      isReadOnly={!isEdit}
                      borderBottomColor={Colors.healthCheckInputBottomLine}
                      placeholder={t(item.key)}
                      name={item.key}
                      color={Colors.black}
                      fontSize={16}
                      value={item.value?.toString()}
                      onChangeText={(value) => updateValue(item.key, value)}
                    />
                  ) : (
                    <Text
                      marginY={2}
                      width={"100%"}
                      fontStyle={"bold"}
                      textAlign={"end"}
                      fontSize={16}
                      color={Colors.black}
                    >
                      {item.value?.toString() ?? "--"}
                    </Text>
                  )}
                </Stack>
              </HStack>
            </FormControl>
          )}
        />
        {isEdit && (
          <Button
            backgroundColor={Colors.transparent}
            _text={{ color: Colors.transparent }}
          >
            ' '
          </Button>
        )}
      </Box>
      {isEdit && (
        <Box
          style={{
            width: "100%",
            // backgroundColor: Colors.redError,
            paddingTop: 0,
            paddingBottom: 0,
            position: "absolute",
            bottom: 0,
          }}
        >
          <Box
            style={{
              flex: 1,
              width: "100%",
              // backgroundColor: Colors.redError,
              paddingTop: 0,
              paddingBottom: 0,
              flexDirection: "row",
            }}
          >
            <Stack flex={1}>
              <Button
                borderRadius={0}
                backgroundColor={Colors.primaryContainerBg}
                _text={{ color: Colors.black, fontSize: 16 }}
                onPress={() => navigation.pop()}
              >
                {t("Cancel")}
              </Button>
            </Stack>

            <View style={{ width: 1 }} />

            <Stack flex={1}>
              <Button
                borderRadius={0}
                backgroundColor={Colors.primaryContainerBg}
                _text={{ color: Colors.black, fontSize: 16 }}
                onPress={() => handleClick()}
              >
                {t("Save")}
              </Button>
            </Stack>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Edit;
